/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */


(function($) {

    window.bootstrapScreenSizes = {
        screenXsMin:    480,
        screenSmMin:    768,
        screenMdMin:    992,
        screenLgMin:   1200,
        screenXsMax:    767,
        screenSmMax:    991,
        screenMdMax:    1999
    };


    window.getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

          new WOW().init();

          $('.intro-more').each(function (){

              var btn = $(this);
              var text = btn.parent().prev('.text');
              if(text.is(':empty')){
                  btn.hide();
              }else {

                  btn.on("click", function () {

                      text.stop().slideToggle(function () {

                          if (text.is(":visible")) {
                              btn.text("X");
                          } else {
                              btn.text("...");
                          }
                      });
                  });
              }
          });

            $(function() {
                var box = $('.patronato_video_box .box');

                box.click(function () {
                    var preview = $(this).find('a');
                    var video = $(this).find('.video');
                    var iframe = video.find('iframe');

                    $(this).css('height', $(this).height());
                    iframe.attr('width', $(this).width());
                    iframe.attr('height', $(this).height());


                    iframe.attr('src', preview.attr('data-video'));
                    preview.hide();
                    video.show();

                });
            });

          $('.random-item').each(function(){

              var area = $(this);

              var items = area.find('.item');
              var chooseId = Math.floor(Math.random() * items.length);
              var selected = $(items[chooseId]).find('.textwidget').html();

              area.html(selected);

          });

          //fix video
          $('.modal').each(function(){
              var src = $(this).find('iframe').attr('src');

              $(this).on('click', function(){

                  $(this).find('iframe').attr('src', '');
                  $(this).find('iframe').attr('src', src);

              });
          });

          //fix viewport dashboard
          var body = $('body');
          var neededWidth = $(window).width() - 20;
          var isIEMobile = navigator.userAgent.match(/iemobile/i);
          var needResize = !isIEMobile && body.is(".is-app") && $(window).width() < 768;

          if(needResize) {
              $('.home header.navbar .brand, .home-dashboard, .app-soluzioniperte-single, footer').each(function () {
                  var item = $(this);
                  var wrapper = $("<div/>");

                  var zoom = neededWidth / item.width();

                  var originalHeight = item.get(0).getBoundingClientRect().height;

                  item.css({
                      'transform': 'scale(' + zoom + ')',
                      'transform-origin': 'top'
                  });

                  var newHeight = item.get(0).getBoundingClientRect().height;
                  var margin = newHeight - originalHeight;

                  item.parent().css({
                      'margin-bottom': margin
                  });

                  console.log(newHeight, originalHeight);

                  // console.log(item.height(), newHeight);
                  //
                  // item.css({
                  //     height: newHeight,
                  // });
                  //
                  // wrapper.addClass(item.attr("class"));
                  //
                  //
                  // item.wrapInner(wrapper);
              });
          }

          // var viewport = document.getElementById("viewport");
          //
          // var realWidth = 264;
          //
          // var updateViewport = function(){
          //     var width = $(window).width();
          //     if(body.is(".is-app") && width < 768) {
          //          var zoom = width / realWidth;
          //         // viewport.setAttribute("content", "initial-scale=" + zoom);
          //     }else{
          //         // viewport.setAttribute("content", "width=device-width, initial-scale=1");
          //     }
          // };
          // updateViewport();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

          var fixedEncodeURIComponent = function (str) {
              return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
                  return '%' + c.charCodeAt(0).toString(16);
              });
          };

          var form = $('#footer-map-search');

          var action = form.attr('action');

          var autocomplete = new google.maps.places.Autocomplete(form.find('input[name=q]').get(0), {types: ['geocode']});

          autocomplete.addListener('place_changed', function () {

              action += "?q=" + fixedEncodeURIComponent(autocomplete.getPlace().formatted_address);

              window.location.href = action;
          });


      },
      finalize: function() {

          var wrapper = $('.wrap.home .slider-bg-wrapper');

          $('.wrap.home .slider-bg').anythingSlider({
              theme : "minimalist-square",
              expand              : true,
              buildNavigation     : false,
              buildStartStop      : false,
              hashTags            : false
          }).bind('slide_begin', function(e, slider){
              wrapper.removeClass( "slide_1 slide_2 slide_3 slide_4 slide_5 slide_6 slide_7 slide_8 slide_9" );
              wrapper.addClass(slider.$targetPage.attr('data-slidekey'));
          });

          wrapper.addClass($('.wrap.home .slider-bg .slide.activePage').attr('data-slidekey'));


          $('.wrap.home .slider-news-wrapper .slider-news .slider').anythingSlider({
              theme : "minimalist-square",
              expand              : true,
              buildArrows         : false,
              buildNavigation     : true,
              buildStartStop      : false,
              autoPlay            : true,
              hashTags            : false,
              delay               : 7000,
              resumeDelay         : 0,
              autoPlayLocked      : true

          });

          $('.wrap.home .news-block-wrapper .list-news').anythingSlider({
              theme : "minimalist-square",
              mode                  :'vertical',
              //expand              : true,
              buildArrows         : false,
              buildNavigation     : true,
              buildStartStop      : false,
              autoPlay            : true,
              hashTags            : false,
              delay               : 7000,
              resumeDelay         : 0,
              autoPlayLocked      : true

          });

          //app
          var appNewsBox = $('.is-app .news.box ');
          var appNewsSlider = appNewsBox.find('.slider').anythingSlider({
              theme : "minimalist-square",
              expand              : true,
              buildArrows         : false,
              buildNavigation     : false,
              buildStartStop      : false,
              autoPlay            : true,
              hashTags            : false,
              delay               : 2500,
              resumeDelay         : 0,
              autoPlayLocked      : true
          });

          appNewsBox.find('img, .title').click(function(){
              appNewsSlider.data('AnythingSlider').startStop(false);
              appNewsBox.find('.info').addClass('open');
          });

          appNewsBox.find('.btn-close').click(function(){
              appNewsSlider.data('AnythingSlider').startStop(true);
              appNewsBox.find('.info').removeClass('open');
          });

        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
